
import { supabase } from '../client';
import { getCurrentUserOrganizationId } from '../products/organization';
import { Shop } from './types';

export async function getShops(): Promise<Shop[]> {
  try {
    // Récupérer l'ID d'organisation de manière fiable
    const storedOrgId = localStorage.getItem('currentOrganizationId');
    const organizationId = storedOrgId || await getCurrentUserOrganizationId();
    
    if (!organizationId) {
      console.error('[getShops] No organization ID found for filtering shops');
      
      // Tentative de récupération des boutiques sans filtre d'organisation comme fallback
      console.warn('[getShops] Trying to fetch all shops without organization filter as fallback');
      
      const { data: allShops, error: allShopsError } = await supabase
        .from('shops')
        .select('*')
        .order('created_at', { ascending: false });
        
      if (allShopsError) {
        console.error('[getShops] Error fetching all shops:', allShopsError);
        return [];
      }
      
      console.log(`[getShops] Retrieved ${allShops?.length || 0} shops without organization filter`);
      return allShops || [];
    }
    
    console.log(`[getShops] Fetching shops for organization: ${organizationId}`);
    
    const { data, error } = await supabase
      .from('shops')
      .select('*')
      .eq('organization_id', organizationId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('[getShops] Error fetching shops:', error);
      throw error;
    }

    console.log(`[getShops] Retrieved ${data?.length || 0} shops`);
    return data || [];
  } catch (error) {
    console.error('[getShops] Exception in getShops:', error);
    return [];
  }
}
